import React from "react";

import { useParams } from "@Libs/Router/hooks/useParams";

import { PhoneNumberInputStep } from "../../Components/PhoneNumberInputStep";
import { PhoneNumberCodeStep } from "../../Components/PhoneNumberCodeStep";

export const PhoneNumberVerificationRouter: React.FC = () => {
  const steps: string[] = ["form", "verify"];
  const { step } = useParams(["PHONE_NUMBER_VERIFICATION"]);

  return (
    <>
      {(!step || step === steps[0]) && <PhoneNumberInputStep />}
      {step === steps[1] && <PhoneNumberCodeStep />}
    </>
  );
};
